import { IconoSirenaMapa } from 'modelos/src';

/**
 * Íconos elegibles para las sirenas del mapa de Cobertura de la app nativa, con su SVG para la vista
 * previa. Espejo de `MapaIconos.kt` en seguridad-boton-nativo: mismo pin y mismos glifos Tabler. Sumar
 * uno acá implica sumarlo allá (y release de la app); una app vieja muestra el pin por defecto.
 */
export const OPCIONES_ICONO_SIRENA: {
  valor: IconoSirenaMapa;
  nombre: string;
}[] = [
  { valor: 'default', nombre: 'Pin (por defecto)' },
  { valor: 'sirena', nombre: 'Sirena' },
  { valor: 'megafono', nombre: 'Megáfono' },
  { valor: 'antena', nombre: 'Antena' },
  { valor: 'custom', nombre: 'Imagen propia (PNG)' },
];

/** Glifos Tabler outline (viewBox 24x24): `urgent`, `speakerphone`, `building-broadcast-tower`. */
const GLIFOS: Partial<Record<IconoSirenaMapa, string>> = {
  sirena:
    '<path d="M8 16v-4a4 4 0 0 1 8 0v4" /><path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" />' +
    '<path d="M6 17a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1l0 -2" />',
  megafono:
    '<path d="M18 8a3 3 0 0 1 0 6" /><path d="M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5" />' +
    '<path d="M12 8l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8" />',
  antena:
    '<path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M16.616 13.924a5 5 0 1 0 -9.23 0" />' +
    '<path d="M20.307 15.469a9 9 0 1 0 -16.615 0" /><path d="M9 21l3 -9l3 9" /><path d="M10 19h4" />',
};

/** Azul de "sin estado" de la app: el color con el que se ven todas si no se muestra el estado. */
const AZUL_NEUTRA = '#1565C0';

/**
 * SVG del pin de sirena (36x48, como en la app) con el glifo de [valor], o el punto blanco del pin
 * por defecto. El borde blanco sale de dibujar la silueta dos veces: primero con trazo, después el
 * relleno encima, así el borde sigue el contorno de cabeza + cola sin cruzarla.
 */
export function svgPinSirena(
  valor: IconoSirenaMapa | null | undefined,
): string {
  const silueta =
    '<circle cx="18" cy="16.56" r="14.4" /><polygon points="9.07,24.48 18,46.56 26.93,24.48" />';
  const glifo = valor ? GLIFOS[valor] : undefined;
  const centro = glifo
    ? `<g transform="translate(9 7.56) scale(0.75)" fill="none" stroke="#fff" stroke-width="2.64" ` +
      `stroke-linecap="round" stroke-linejoin="round">${glifo}</g>`
    : '<circle cx="18" cy="16.56" r="4.9" fill="#fff" />';
  return (
    `<svg viewBox="0 0 36 48" width="27" height="36">` +
    `<g fill="#fff" stroke="#fff" stroke-width="4.3" stroke-linejoin="round">${silueta}</g>` +
    `<g fill="${AZUL_NEUTRA}">${silueta}</g>${centro}</svg>`
  );
}
